import React, { useState, useEffect } from "react";
import { Box, Container, Tabs, Tab, Typography, CircularProgress } from "@mui/material";
import {
  Assignment,
  Description,
  Group,
  ShoppingCart,
  BarChart,
  Warning,
  AttachMoney,
  Business,
  TableChart,
  Image,
  Folder,
  Send,
  Visibility,
} from "@mui/icons-material";
import CampaignProfile from "../components/forms/startup/CampaignProfile"; 
import CampaignTeam from "../components/forms/startup/CampaignTeam";
import NadirJs from "../components/forms/startup/Nadir";
import NadirMarket from "../components/forms/startup/NadirMarket";
import Risk from "../components/forms/startup/Risk";
import PatentForm from "../components/forms/startup/Cdocument";
import OtherDocuments from "../components/forms/startup/OtherDocuments";import StartupAnalysis from "../components/forms/startup/StartupAnalysis";
import Media from "../components/forms/startup/media/Media";
import Company from "../components/forms/startup/company/company";
import Funding from "../components/forms/startup/funding/funding";
import Approval from "../components/forms/startup/approval/approval";
import Preview from "../components/forms/startup/preview/preview";
import EditableTable from "./EditableTable";
import DynamicTable from "./DynamicTable";
import Financial from "../components/forms/startup/financial/financial";
import { useParams } from 'react-router-dom';
import { ApiHelper } from "../utils/apiHelper";
import { useTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import useAccountInfo from "../hooks/useAccountInfo";

const CampaignsRegister = () => {
  const theme = useTheme();
  const { startupId } = useParams();
  const [selectedTab, setSelectedTab] = useState(0);
  const [campaignData, setCampaignData] = useState(null);
  const [loading, setLoading] = useState(true);

  const { accountInfo, loading: accountInfoLoading, error: accountInfoError } = useAccountInfo(); // Custom hook

  useEffect(() => {
    const fetchCampaignData = async () => {
      if (!startupId) {
        setLoading(false);
        return;
      }

      try {
        const response = await ApiHelper.get(`/startup/${startupId}`);
        if (response.data.code === "00000") {
          setCampaignData(response.data.response);
        }
      } catch (error) {
        console.error("Error fetching campaign data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCampaignData();
  }, [startupId]);

  // URL'den hash'i kontrol et ve başlangıç tab'ini ayarla
  React.useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    const tabNames = ['profile', 'documents', 'team', 'product', 'market', 'analysis', 'risks', 
                     'funding', 'company', 'financial', 'media', 'documents-other', 'approval', 'preview'];
    const tabIndex = tabNames.indexOf(hash);
    if (tabIndex !== -1) {
      setSelectedTab(tabIndex);
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Tab değiştiğinde URL hash'ini güncelle
    const tabNames = ['profile', 'documents', 'team', 'product', 'market', 'analysis', 'risks', 
                     'funding', 'company', 'financial', 'media', 'documents-other', 'approval', 'preview'];
    window.location.hash = tabNames[newValue];
  };

  if (loading || accountInfoLoading) {
    return (
      <Container sx={{ paddingY: 6 }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  const menuItems = [
    { label: "Kampanya Profili", icon: <Assignment />, value: 0 },
    { label: "Belge/Ödül/Hukuk", icon: <Description />, value: 1 },
    { label: "Takım", icon: <Group />, value: 2 },
    { label: "Ürün/Üretim Modeli", icon: <ShoppingCart />, value: 3 },
    { label: "Pazar/Rekabet/Hedef", icon: <BarChart />, value: 4 },
    { label: "Analizler", icon: <BarChart />, value: 5 },
    { label: "Riskler", icon: <Warning />, value: 6 },
    { label: "Fonlama", icon: <AttachMoney />, value: 7 },
    { label: "Kuruluş", icon: <Business />, value: 8 },
    { label: "Finansal Tablolar", icon: <TableChart />, value: 9 },
    { label: "Görsel/Video", icon: <Image />, value: 10 },
    { label: "Diğer Dokümanlar", icon: <Folder />, value: 11 },
    { label: "Onaya Gönder", icon: <Send />, value: 12 },
    { label: "Önizleme", icon: <Visibility />, value: 13 },
  ];

  console.log(accountInfo);
  if (accountInfo?.userType === "corporate") {
    menuItems.splice(8, 1);
  }

  return (
    <Container sx={{ paddingY: 6 }}>
      <Box sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", sm: "row" }, 
        gap: 3,
      }}>
        <Box sx={{ 
          width: { xs: "100%", sm: "25%" },
          bgcolor: 'transparent',
          borderRadius: 2,
          border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
        }}>
          <Tabs
            orientation={window.innerWidth >= 600 ? "vertical" : "horizontal"}
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              minHeight: 400,
              borderRadius: 2,
              '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
              },
              '& .MuiTabs-flexContainer': {
                gap: 1,
                padding: 2,
              },
              '& .MuiTab-root': {
                minHeight: 48,
                borderRadius: 1.5,
                textAlign: "left",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingLeft: 2.5,
                paddingRight: 2.5,
                fontWeight: 500,
                fontSize: "0.875rem",
                textTransform: "capitalize",
                color: theme.palette.mode === 'light' 
                  ? theme.palette.grey[600] 
                  : theme.palette.grey[400],
                '&:hover': {
                  bgcolor: theme.palette.mode === 'light'
                    ? alpha(theme.palette.primary.main, 0.08)
                    : alpha(theme.palette.primary.main, 0.15),
                  color: theme.palette.primary.main,
                },
                '&.Mui-selected': {
                  bgcolor: theme.palette.mode === 'light'
                    ? alpha(theme.palette.primary.main, 0.12)
                    : alpha(theme.palette.primary.main, 0.2),
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                  '&:hover': {
                    bgcolor: theme.palette.mode === 'light'
                      ? alpha(theme.palette.primary.main, 0.18)
                      : alpha(theme.palette.primary.main, 0.25),
                  },
                },
                transition: theme.transitions.create(['background-color', 'color'], {
                  duration: theme.transitions.duration.shorter,
                }),
              },
            }}
          >
            {menuItems.map((item) => (
              <Tab
                key={item.value}
                icon={
                  <Box sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    marginRight: 1.5,
                    '& svg': {
                      fontSize: 20,
                    },
                  }}>
                    {item.icon}
                  </Box>
                }
                iconPosition="start"
                label={item.label}
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ width: { xs: "100%", sm: "75%" } }}>
          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{ 
              textTransform: "capitalize", 
              fontSize: "1.5rem",
              color: theme.palette.mode === 'light' 
                ? theme.palette.grey[800] 
                : theme.palette.grey[100],
              fontWeight: 600,
              mb: 3,
            }}
          >
            {/* menuItems.find((item) => item.value === selectedTab)?.label */}
          </Typography>
          <Box
            sx={{
              padding: 3,
              bgcolor: 'transparent',
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
              boxShadow: theme.customShadows.card,
            }}
          >
            {selectedTab === 0 && <CampaignProfile initialData={campaignData?.profile} />}
            {selectedTab === 1 && <PatentForm initialData={campaignData?.patent} />}
            {selectedTab === 2 && <CampaignTeam />}
            {selectedTab === 3 && <NadirJs />}
            {selectedTab === 4 && <NadirMarket/>}
            {selectedTab === 5 && <StartupAnalysis/>}
            {selectedTab === 6 && <Risk/>}
            {selectedTab === 7 && <Funding/>}
            {selectedTab === 8 && <Company/>}
            {selectedTab === 9 &&  <Financial/>}
            {selectedTab === 10 && <Media/>}
            {selectedTab === 11 && <OtherDocuments/>}
            {selectedTab === 12 && <Approval/>}
            {selectedTab === 13 && <Preview/>}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default CampaignsRegister;
